export const UNCATEGORIZED = 'uncategorized';
